import React from 'react';
import './Header.css';

interface Tab {
  label: string;
  active: boolean;
}

interface HeaderProps {
  projectName: string;
  subProject: string;
  monitorPlanningTabs: Tab[];
  onTabChange: (tabLabel: string) => void;
  apiBaseUrl?: string;
  onEditApiBaseUrl?: (next: string) => void;
}

const Header: React.FC<HeaderProps> = ({
  projectName,
  subProject,
  monitorPlanningTabs,
  onTabChange,
  apiBaseUrl,
  onEditApiBaseUrl
}) => {
  const [editing, setEditing] = React.useState(false);
  const [value, setValue] = React.useState(apiBaseUrl || '');

  React.useEffect(() => {
    setValue(apiBaseUrl || '');
  }, [apiBaseUrl]);

  return (
    <div className="header">
      <div className="header-top">
        <div className="breadcrumb">
          {projectName} &gt; {subProject}
        </div>
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>
          {!editing ? (
            <>
              <span style={{ fontSize: 12, color: '#6b7280' }}>Endpoint:</span>
              <span style={{ fontSize: 12 }}>{apiBaseUrl || 'Not set'}</span>
              <button onClick={() => setEditing(true)} style={{ fontSize: 12, padding: '4px 8px' }}>Edit</button>
            </>
          ) : (
            <>
              <input
                type="text"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="http://localhost:4020"
                style={{ fontSize: 12, padding: '4px 6px', minWidth: 260 }}
              />
              <button
                onClick={() => { onEditApiBaseUrl && onEditApiBaseUrl(value); setEditing(false); }}
                style={{ fontSize: 12, padding: '4px 8px' }}
              >Save</button>
              <button onClick={() => { setValue(apiBaseUrl || ''); setEditing(false); }} style={{ fontSize: 12, padding: '4px 8px' }}>Cancel</button>
            </>
          )}
        </div>
      </div>

      <div className="header-tabs">
        {monitorPlanningTabs.map((tab) => (
          <div
            key={tab.label}
            className={`header-tab ${tab.active ? 'active' : ''}`}
            onClick={() => onTabChange(tab.label)}
          >
            {tab.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Header;
